module.exports = __webpack_public_path__ + "static/media/sikh-prayer.eee287af.mp3";